/* eslint-disable */
import { errorMsg } from '../constants/messages';

const partnerServicesFormData = [
  {
    name: 'id',
    label: 'Service ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Service ID', allowAddRecordClick: false },
    isTableHeader: true,
    default: '',
  },
  {
    name: 'name',
    label: 'Service Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Service Name', allowAddRecordClick: true },
    isTableHeader: true,
    default: '',
  },
  {
    name: 'parameters',
    label: 'Parameters',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Parameters', columnType: 'parameters' },
    isTableHeader: true,
    default: '',
  },
  {
    name: 'documitraFee',
    label: 'Documitra Fee',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Documitra Fee', columnType: 'currency' },
    isTableHeader: true,
    default: '',
  },
  {
    name: 'createdAt',
    label: 'Created',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Created', columnType: 'simpleDate', enableSort: true },
    isTableHeader: true,
    default: '',
  },

  {
    name: 'actions',
    label: 'Actions',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Actions', columnType: 'actions' },
    isTableHeader: true,
    default: '',
  },
];

export { partnerServicesFormData };
